import React, { useState } from 'react';
import { Dialog, DialogContent, DialogTitle, TextField, Typography, InputAdornment, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';

const ManualHistorico = ({ open, handleClose }) => {
    const [searchTerm, setSearchTerm] = useState('');

    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
    };

    const textContent = `
**1 - Funcionamento do componente de Conciliação histórico contábil e descrição dos campos **

**1.1 Objetivo:**  
    O sistema é projetado para facilitar o processo de conciliação de históricos, débitos e créditos. Na conciliação dos históricos, o sistema verifica se existem dois ou mais históricos com o mesmo número de registro, por exemplo, nota fiscal. A conciliação do histórico ocorre de 1 para 1 ou 1 para N. Ou seja, posso ter um histórico com um registro de crédito e um de débito, ou então vários registros de crédito em um único histórico e múltiplos históricos com apenas um registro, e vice-versa.

Por exemplo, de 1 para 1 temos um histórico de crédito:

    Lançamento NF 123

e um registro de débito:

    Lançamento NF 123

De 1 para N refere-se a um histórico de crédito ou débito com vários registros:

    Lançamento NF 123, 456, 678, 789

e vários históricos com registros de crédito ou débito:

    Lançamento NF 123
    Lançamento NF 456
    Lançamento NF 678
    Lançamento NF 789

Além disso, o sistema efetua a conciliação vários lançamentos com o mesmo registro, ou seja créditos e/ou débitos com o mesmo número de registro.
Por exemplo lançamentos de crédito:
Lançamento NF 123
Lançamento NF 123
Lançamento NF 123

e  lançamentos de débitos:

Lançamento NF 123
Lançamento NF 123

O sistema permite também que seja efetuada a conciliação de múltiplas empresas ao mesmo tempo. Para isso, é informado na coluna Razão Social a qual cliente/empresa os registros pertencem. A conciliação é realizada individualmente para cada razão social.

**1.2 Carregamento de Arquivos:**  
- **Padrão no histórico:** Informar quais os padrões no histórico que o sistema deverá considerar para localizar os registros a serem conciliados. Por exemplo, se o registro a ser localizado é a nota fiscal e no histórico estiver como NFe 123, o padrão será NFe. Se existir mais de um padrão, por exemplo, NFe, NFE e NF, devem ser inseridos e separados por ";". Por exemplo: NFe;NFE;NF.

- **Sistema de origem:** Sistema ao qual o arquivo foi gerado. Caso tenha sido gerado por um sistema não cadastrado e adequado ao layout padrão, deve-se utilizar a opção Padrão.

**1.3 Tabela de resultados:**

Todas as colunas podem ser ordenadas dando um duplo clique sobre o cabeçalho.

O campo filtro localiza e filtra o valor desejado em todas as colunas da tabela de resultados.

O campo Filtrar por filtra a tabela de resultados por:

- **Conciliado:** Histórico e valor conciliado
- **Parcialmente Conciliado:** Histórico ou valor conciliado
- **Não Conciliado:** Histórico e valor não conciliado

**Colunas da tabela de resultados:**

- **Data:** Data do histórico
- **Créditos:** Valor da coluna crédito
- **Débitos:** Valor da coluna débito
- **Conciliação Histórico:** Resultado da conciliação do histórico, ou seja, se existem dois ou mais históricos para a conciliação
- **Conciliação Valor:** Resultado da conciliação dos valores dos históricos, ou seja, se os valores de crédito de um histórico são iguais ao valor de débito do outro
- **Histórico:** Histórico utilizado para a conciliação
- **Lote:** Lote gerado pelo sistema de origem
- **Razão Social:** Razão social da empresa que foi conciliada
- **Registro:** Número extraído do histórico para realizar a conciliação com base no que foi definido no campo Padrão no histórico

Na tabela de resultados, a coluna Saldo Títulos informa qual o saldo pendente quando existem registros de 1 para N. Ou seja, por exemplo, se um histórico tiver 5 notas fiscais (12, 23, 34, 45, 56) com o valor de 200 cada, totalizando 1000, e existirem somente quatro históricos individuais, ficará pendente o valor de 200, que será exibido nessa coluna.

**Índice:** Valor gerado para identificar registros de 1 para N, ou seja, todos os registros que pertencem a uma mesma conciliação têm o mesmo valor. Usando o exemplo anterior, temos os históricos:

- Lançamento NF 123, 456, 678, 789
- Lançamento NF 123
- Lançamento NF 456
- Lançamento NF 678
- Lançamento NF 789

Dessa forma, todos esses históricos têm o mesmo valor de índice para facilitar a sua localização e agrupamento.

`;

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
            <DialogTitle>
                Manual de conciliação Histórico
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    style={{ position: 'absolute', right: 8, top: 8 }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <TextField
                    fullWidth
                    placeholder="Buscar..."
                    onChange={handleSearch}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                />
                <Typography component="pre" variant="body1" style={{ whiteSpace: 'pre-wrap', marginTop: '16px', fontSize: '14px', lineHeight: '1.6' }}>
                    {textContent.split('\n').map((line, index) => (
                        <span
                            key={index}
                            style={{
                                backgroundColor: line.toLowerCase().includes(searchTerm.toLowerCase()) && searchTerm ? 'yellow' : 'inherit',
                            }}
                        >
                            {line}
                            <br />
                        </span>
                    ))}
                </Typography>
            </DialogContent>
        </Dialog>
    );
};

export default ManualHistorico;
